import { memo } from 'react'
import { MasterSelector } from 'redux/selector';
import OptionMessage from '../OptionMessage';

const Income = (props) => {
  return <OptionMessage {...props} selector={MasterSelector.incomeSourceOptions} />
}

export default memo(Income);